/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gift_Option_200_DescInputs */

const es_gift_option_200_desc = /** @type {(inputs: Gift_Option_200_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La sal corre por tus venas más que la sangre.`)
};

const gl_gift_option_200_desc = /** @type {(inputs: Gift_Option_200_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A sal corre polas túas veas máis que a sangue.`)
};

const en_gift_option_200_desc = /** @type {(inputs: Gift_Option_200_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salt runs in your veins more than blood.`)
};

/**
* | output |
* | --- |
* | "Salt runs in your veins more than blood." |
*
* @param {Gift_Option_200_DescInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const gift_option_200_desc = /** @type {((inputs?: Gift_Option_200_DescInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gift_Option_200_DescInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_gift_option_200_desc(inputs)
	if (locale === "en") return en_gift_option_200_desc(inputs)
	return es_gift_option_200_desc(inputs)
});